import z from 'zod';

export const contentTypesLiteral = z.enum([
  'module', // class
  'article',
  'onDemandUnit',
  'learnerOccupation',
  'auLearningContentType',
  'blockPdf',
  'eventLocation',
  'product',
  'onDemandUnitType',
]);
